export default {
  name: 'SubItems',
  functional: true,
  render(createElement, { props }) {
    // eslint-disable-next-line global-require,@typescript-eslint/no-var-requires
    const Item = require('./Item.js').default;
    return props.items.map(item => createElement(Item, {
      props: {
        item,
        breadcrumb: props.breadcrumb || '',
        questions: props.questions,
        responseSets: props.responseSets,
        hasMultiplePages: props.hasMultiplePages,
        questionsToFetch: props.questionsToFetch,
      },
    }));
  },
};
